
let jwtToken: string = ""
export function UpdateJwtToken(token: string) {
    jwtToken = token
}

export function GetJwtToken() {
    return jwtToken
}
